
export const availableWorkflows: Array<{ id: string, name: string }> = [
    { "id": "latest", "name": "Latest execution" },
    { "id": "gps_extraction", "name": "GPS extraction" },
    { "id": "image_extraction", "name": "Image extraction" },
    { "id": "only_ia", "name": "Only IA" },
    { "id": "ia_preannotation", "name": "IA preannotation" },
    { "id": "cvat_export", "name": "CVAT export" },
];
export const enumExecutionStatus = {
    "any": "any",
    "none": "none",
    "started": "started",
    "error": "error",
    "canceled": "canceled",
    "completed": "completed"
}
